import { Children, type ReactNode } from 'react';

import { isSlot } from '../../../../../core/utils/is-slot.js';
import { ThresholdIndicator } from '../slots/ThresholdIndicator.js';
import { XAxis } from '../slots/XAxis.js';
import { YAxis } from '../slots/YAxis.js';
import type { SparklineThresholdIndicatorProps } from '../types/sparkline-thresholds-props.js';
import type { SparklineXAxisProps } from '../types/sparkline-x-axis-props.js';
import type { SparklineYAxisProps } from '../types/sparkline-y-axis-props.js';

export function iterateSparklineSlots(children: ReactNode) {
  const thresholds: SparklineThresholdIndicatorProps[] = [];
  let xAxis: SparklineXAxisProps | undefined = undefined;
  let yAxis: SparklineYAxisProps | undefined = undefined;

  Children.forEach(children, (child) => {
    if (isSlot(child, ThresholdIndicator)) {
      const thresholdProps = child.props;
      thresholds.push(thresholdProps);
    } else if (isSlot(child, XAxis)) {
      xAxis = {
        ...xAxis,
        ...child.props,
      };
    } else if (isSlot(child, YAxis)) {
      yAxis = {
        ...yAxis,
        ...child.props,
      };
    }
  });

  return {
    thresholds,
    xAxis,
    yAxis,
  };
}
